import Contact from "../pages/contact/page";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import SwordfishPage from "../pages/products/SwordfishPage";
import TunaPage from "../pages/products/TunaPage";
import SalmonPage from "../pages/products/SalmonPage";
import ScallopsPage from "../pages/products/ScallopsPage";
import LobsterPage from "../pages/products/LobsterPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/swordfish",
    element: <SwordfishPage />,
  },
  {
    path: "/tuna",
    element: <TunaPage />,
  },
  {
    path: "/salmon",
    element: <SalmonPage />,
  },
  {
    path: "/scallops",
    element: <ScallopsPage />,
  },
  {
    path: "/lobster",
    element: <LobsterPage />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;